module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1015.c76b1f39.png";